import HouseholdContainer from './container/HouseholdContainer'

// Sync route definition
export default {
  path: '/households/:householdId',
  component: HouseholdContainer,
}
